import { createGlobalStyle } from 'styled-components'


const GlobalStyles = createGlobalStyle`
    @font-face {
        font-family: 'Open Sans';
        src: url("/public/fonts/Open_Sans/OpenSans-Bold.ttf");
        font-style: normal;
        font-weight: 700;
        font-display: swap;
    }
    
    @font-face {
        font-family: 'Open Sans';
        src: url("/public/fonts/Open_Sans/OpenSans-ExtraBold.ttf");
        font-style: normal;
        font-weight: 800;
        font-display: swap;
    }
    
    @font-face {
        font-family: 'Open Sans';
        src: url("/public/fonts/Open_Sans/OpenSans-Light.ttf");
        font-style: normal;
        font-weight: 300;
        font-display: swap;
    }
    
    @font-face {
        font-family: 'Open Sans';
        src: url("/public/fonts/Open_Sans/OpenSans-Regular.ttf");
        font-style: normal;
        font-weight: 400;
        font-display: swap;
    }
    
    @font-face {
        font-family: 'Open Sans';
        src: url("/public/fonts/Open_Sans/OpenSans-SemiBold.ttf");
        font-style: normal;
        font-weight: 600;
        font-display: swap;
    }
    
    @font-face {
        font-family: 'Open Sans';
        src: url("/public/fonts/Open_Sans/OpenSans-Bold.ttf");
        font-style: normal;
        font-weight: 700;
        font-display: swap;
    }

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: Open-Sans, sans-Serif;
        -webkit-tap-highlight-color: rgba(255,255,255,0);
        -webkit-text-size-adjust: none;
        
        &::-webkit-scrollbar {
            width: 0;
        }
    }
    
    body {
        height: 100vh;
        height: 100dvh;
        height: calc(var(--vh,1vh) * 100);
    
        > * {
          width: 100%;
          height: 100%; 
        }
    }
    
    input[type="text"],
    input[type="tel"],
    input[type="email"],
    input[type="password"],
    input[type="tel"],
    input[type="textarea"],
    input[type="radio"],
    textarea,
    input {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
    
    input[type="radio"] {
        display: none;
    }
    
    a, input, button {
        font-family: Open-Sans, sans-Serif;
    }
`;

export default GlobalStyles;